module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_03_6NW26_1SC_GED.f3cf72ea.png";